import _slicedToArray from "/home/shipsy/crm-logistics-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
export var ZoomIn = function ZoomIn(options) {
  // Small enough to hide or show very small part of mark,
  // but bigger enough to not cause bug.
  var ZERO = 0.0001;
  return function (from, _, defaults) {
    var _from = _slicedToArray(from, 1),
      shape = _from[0];
    var _shape$style = shape.style,
      _shape$style$transfor = _shape$style.transform,
      prefix = _shape$style$transfor === void 0 ? '' : _shape$style$transfor,
      _shape$style$fillOpac = _shape$style.fillOpacity,
      fillOpacity = _shape$style$fillOpac === void 0 ? 1 : _shape$style$fillOpac,
      _shape$style$strokeOp = _shape$style.strokeOpacity,
      strokeOpacity = _shape$style$strokeOp === void 0 ? 1 : _shape$style$strokeOp,
      _shape$style$opacity = _shape$style.opacity,
      opacity = _shape$style$opacity === void 0 ? 1 : _shape$style$opacity;
    var keyframes = [{
      transform: "".concat(prefix, " scale(").concat(ZERO, ")").trimStart(),
      fillOpacity: 0,
      strokeOpacity: 0,
      opacity: 0
    }, {
      transform: "".concat(prefix, " scale(").concat(ZERO, ")").trimStart(),
      fillOpacity: fillOpacity,
      strokeOpacity: strokeOpacity,
      opacity: opacity,
      offset: 0.01
    }, {
      transform: "".concat(prefix, " scale(1)").trimStart(),
      fillOpacity: fillOpacity,
      strokeOpacity: strokeOpacity,
      opacity: opacity
    }];
    var _shape$getBoundingCli = shape.getBoundingClientRect(),
      width = _shape$getBoundingCli.width,
      height = _shape$getBoundingCli.height; // Change transform origin for correct transform.
    shape.setOrigin([width / 2, height / 2]);
    var animation = shape.animate(keyframes, Object.assign(Object.assign({}, defaults), options));
    // Reset transform origin to eliminate side effect for following animations.
    animation.finished.then(function () {
      return shape.setOrigin(0, 0);
    });
    return animation;
  };
};